/**
 * @generated SignedSource<<fa0db3e4d0d121125f401e4c5f8599f4>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorefrontHome_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"StorefrontFeaturedSection_viewer" | "StorefrontMediaSection_viewer" | "useShowSellerSince_viewer">;
  readonly " $fragmentType": "StorefrontHome_viewer";
};
export type StorefrontHome_viewer$key = {
  readonly " $data"?: StorefrontHome_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorefrontHome_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorefrontHome_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorefrontFeaturedSection_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShowSellerSince_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorefrontMediaSection_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "7a19008e95a1f4341d4bed81fbd83e7e";

export default node;
